// @flow

import {
    createRemoteVideoMenuButtonEvent,
    sendAnalytics
} from '../../analytics';
import { rejectParticipantAudio, approveParticipantAudio } from '../../av-moderation/actions';
import { IconMicSlash } from '../../base/icons';
import { MEDIA_TYPE } from '../../base/media';
import { AbstractButton, type AbstractButtonProps } from '../../base/toolbox/components';
import { isRemoteTrackMuted } from '../../base/tracks';
import { muteRemote, unMuteRemote } from '../actions.any';
import { getLocalParticipant, getParticipantByIdOrUndefined, getParticipantById } from '../../base/participants';

export type Props = AbstractButtonProps & {

    /**
     * Boolean to indicate if the audio track of the participant is muted or
     * not.
     */
    _audioTrackMuted: boolean,

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    /**
     * The ID of the participant object that this button is supposed to
     * mute/unmute.
     */
    participantID: string,

    /**
     * The function to be used to translate i18n labels.
     */
    t: Function,
    user: Object,
    participant: Object,
    tracks: Array
};

/**
 * An abstract remote video menu button which mutes the remote participant.
 */
export default class AbstractMuteButton extends AbstractButton<Props, *> {
    accessibilityLabel = 'toolbar.accessibilityLabel.remoteMute';
    icon = IconMicSlash;
    label = 'videothumbnail.domute';
    toggledLabel = 'videothumbnail.muted';

    /**
     * Handles clicking / pressing the button, and mutes the participant.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, participantID } = this.props;

        sendAnalytics(createRemoteVideoMenuButtonEvent(
            'mute',
            {
                'participant_id': participantID
            }));

        dispatch(muteRemote(participantID, MEDIA_TYPE.AUDIO));
        dispatch(rejectParticipantAudio(participantID));

    }

    /**
     * Handles clicking / pressing the button, and unmutes the participant.
     *
     * @private
     * @returns {void}
     */
    _handleUnmuteClick() {
        const { dispatch, participantID } = this.props;

        sendAnalytics(createRemoteVideoMenuButtonEvent(
            'unmute',
            {
                'participant_id': participantID
            }));

        dispatch(unMuteRemote(participantID, MEDIA_TYPE.AUDIO));
        dispatch(approveParticipantAudio(participantID));
        
    }

    /**
     * Renders the item disabled if the participant is muted.
     *
     * @inheritdoc
     */
    _isDisabled() {
        return this.props._audioTrackMuted;
    }

    /**
     * Renders the item toggled if the participant is muted.
     *
     * @inheritdoc
     */
    _isToggled() {
        return this.props._audioTrackMuted;
    }
}

/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @param {Object} ownProps - Properties of component.
 * @private
 * @returns {{
 *      _localParticipant: any,
 *      _audioTrackMuted: boolean
 *  }}
 */
export function _mapStateToProps(state: Object, ownProps: Props) {
    const tracks = state['features/base/tracks'];
    const user = state['features/base/settings'].user;
    // const localParticipant = state['features/base/participants'].find(p => p.local);
    // const localParticipant = state['features/base/participants'].filter(p => p.local);
    const localParticipant = getLocalParticipant(state);
    const participants = state['features/base/participants'];

    return {
        _localParticipant: localParticipant,
        _audioTrackMuted: isRemoteTrackMuted(
            tracks, MEDIA_TYPE.AUDIO, ownProps.participantID),
        user,
        participant: getParticipantByIdOrUndefined(state, ownProps.participantID),
        //participant: Object.keys(participants).find(p => p.id === ownProps.participantID),
        tracks
    };
}
